import { format, isPast } from 'date-fns';

import { Translate } from '@src/i18n/useTranslate';

export const getRescheduleDeadline = (until: string | null, i18n: Translate['i18n']) => {
  if (!until) {
    return i18n('reschedule_info_reschedule_until_expired');
  }

  const untilDate = new Date(until);

  if (isPast(untilDate)) {
    return i18n('reschedule_info_reschedule_until_expired');
  }

  return format(untilDate, 'dd/MM/yyyy HH:mm');
};
